import React from 'react'
import FlexContainer from 'core-system/FlexContainer'
import styled from 'styled-components'
import Text from 'core-system/Text'
import PlatformSvg from 'core-system/Icons/PlatformSvg'
import FormattingUtils from 'shared/FormattingUtils'
import Divider from 'core-system/Divider'
import palette from 'core-system/Themes/palette'
import Chip from 'core-system/Chip'
import { Micromobility as MicromobilityIcon } from 'core-system/Icons/Sidebar'

const Container = styled.div`
  ${(props) => props.theme.baseCard};
`
const IconContainer = styled(FlexContainer)`
  width: 2.5rem;
  height: 2.5rem;
  background-color: ${(props) => props.theme.palette.primary.pink300};
  border-radius: 50%;
  margin-right: 1rem;
`

interface OTPOptionsProps {
  totalBudget: number
  transactionLimit: number
  micromobilityActive?: boolean
}

const OTPOptions = React.memo((props: OTPOptionsProps) => {
  const { totalBudget, transactionLimit, micromobilityActive } = props
  return (
    <Container>
      <Text variant='h5'>Total Budget</Text>
      <FlexContainer alignItems='center'>
        <PlatformSvg
          folder='metrics'
          variant='employeeCostPurple'
          width={40}
          height={40}
        />
        <Text variant='h2' marginLeft='0.5rem'>
          {FormattingUtils.formatDollar(totalBudget, 0)}
        </Text>
      </FlexContainer>
      <Divider marginY='1rem' />
      <FlexContainer justifyContent={'space-between'} alignItems='center'>
        <div>
          <Text
            variant='caption'
            captionTitle
            textColor={palette.text.secondary}
            marginBottom='0.5rem'
          >
            Purchase Limit Per Commuter
          </Text>
          <Text variant='action3' capitalize={true}>
            {FormattingUtils.formatDollar(transactionLimit, 0)}
          </Text>
        </div>
      </FlexContainer>
      <Divider marginY='1rem' />
      <Text
        variant='caption'
        captionTitle
        textColor={palette.text.secondary}
        marginBottom='0.5rem'
      >
        Program Options
      </Text>
      <FlexContainer
        alignItems='center'
        marginBottom='0.25rem'
        padding='0.5rem'
      >
        <IconContainer center>
          <MicromobilityIcon />
        </IconContainer>
        <Text variant='action3'>Micromobility</Text>
        <Chip
          marginLeft='auto'
          variant={micromobilityActive ? 'green' : 'grey'}
        >
          {micromobilityActive ? 'Active' : 'Disabled'}
        </Chip>
      </FlexContainer>
    </Container>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  OTPOptions.displayName = 'OTPOptions'
}

export default OTPOptions
